export enum ModalNamesEnum {
  AutoScriptOneTutorialVideo = 'AutoScriptOneTutorialVideo',
  AdminEditSetting = 'AdminEditSetting',
  AdminAddBalanceToBillingAccount = 'AdminAddBalanceToBillingAccount',
  AdminBillingAccountRate = 'AdminBillingAccountRate',
  AdminBillingAccountRatesEditor = 'AdminBillingAccountRatesEditor',
  AdminAIModelChoice = 'AdminAIModelChoice',
  AdminCloneJobModal = 'AdminCloneJobModal',
  AdminBillingAccountRatesHistory = 'AdminBillingAccountRatesHistory',
  AdminLeaveOrganizationModal = 'AdminLeaveOrganizationModal',

  ContactSales = 'ContactSales',
  PaymentMethodsHistory = 'PaymentMethodsHistory',
  AddPaymentMethod = 'AddPaymentMethod',

  AutoTopUpSettings = 'AutoTopUpSettings',
  TopUpCreditBalance = 'TopUpCreditBalance',
  Status = 'Status',
  TransactionStatus = 'TransactionStatus',

  PriceModal = 'PriceModal',

  UnlockJob = 'UnlockJob',
  UnlockJobFull = 'UnlockJobFull',

  CreateUserModal = 'CreateUserModal',

  DeleteJobModal = 'DeleteJobModal',
  MoveJobToWSModal = 'MoveJobToWSModal',
  AddWSToTeamModal = 'AddWSToTeamModal',
  MoveJobsToWSModal = 'MoveJobsToWSModal',
  DeleteJobsModal = 'DeleteJobsModal',
  CustomConfirmationModal = 'CustomConfirmationModal',

  ResubmitJobModal = 'ResubmitJobModal',
  AdminResubmitJobModal = 'AdminResubmitJobModal',
  AdminApplyEnhancementModal = 'AdminApplyEnhancementModal',
  AdminLlmCallsModal = 'AdminLlmCallsModal',
  AdminBulkResubmitJobsModal = 'AdminBulkResubmitJobsModal',
  AdminMoveJobModal = 'AdminMoveJobModal',
  AdminRefundJobModal = 'AdminRefundJobModal',

  InviteUserModal = 'InviteUserModal',
  InviteUsersByCsvModal = 'InviteUsersByCsvModal',
  DeleteInvitationModal = 'DeleteInvitationModal',
  ResendInvitationModal = 'ResendInvitationModal',
  AdminInviteUserModal = 'AdminInviteUserModal',

  NewWorkspaceModal = 'NewWorkspaceModal',
  DeleteWorkspaceModal = 'DeleteWorkspaceModal',

  AssignJobModal = 'AssignJobModal',
  GetAssigneeModal = 'GetAssigneeModal',
  GetAssigneeWithoutCommentModal = 'GetAssigneeWithoutCommentModal',
  SearchModal = 'SearchModal',

  AddUserLicenseModal = 'AddUserLicenseModal',

  EditJobNotesModal = 'EditJobNotesModal',
  EditJobCaseModal = 'EditJobCaseModal',
  EditJobTagsModal = 'EditJobTagsModal',
  EditDeadline = 'EditDeadline',

  JobHistory = 'JobHistory',
  ReporterSummaryPreviewModal = 'ReporterSummaryPreviewModal',

  ImageUploadModal = 'ImageUploadModal',
  NewOrganizationModal = 'NewOrganizationModal',

  EditTeamMembersModal = 'EditTeamMembersModal',
  AddTeamToWorkspaceModal = 'AddTeamToWorkspaceModal',

  DeleteRepositoryModal = 'DeleteRepositoryModal',
  DeleteTeamModal = 'DeleteTeamModal',
  NewTeamModal = 'NewTeamModal',
  DeleteMemberModal = 'DeleteMemberModal',
  AssignRepositoryModal = 'AssignRepositoryModal',
  SelectCaseFiles = 'SelectCaseFiles',

  ChooseASOneSubscriptionModal = 'ChooseASOneSubscriptionModal',
  AdminChooseASOneSubscriptionModal = 'AdminChooseASOneSubscriptionModal',
  EditASOneSubscriptionModal = 'EditASOneSubscriptionModal',
  AdminEditASOneSubscriptionModal = 'AdminEditASOneSubscriptionModal',
  ConfirmSubscription = 'ConfirmSubscription',
  ConfirmSubscriptionUpgrade = 'ConfirmSubscriptionUpgrade',
  AdminConfirmSubscription = 'AdminConfirmSubscription',
  ConfirmSubscriptionCancellation = 'ConfirmSubscriptionCancellation',
  AdminConfirmSubscriptionCancellation = 'AdminConfirmSubscriptionCancellation',

  DeleteAPIKey = 'DeleteAPIKey',
  CreateAPIKey = 'CreateAPIKey',

  AddNewASOnePlan = 'AddNewASOnePlan',
  EditASOnePlan = 'EditASOnePlan',

  GenericErrorModal = 'GenericErrorModal',
  GenericConfirmation = 'GenericConfirmation',
  AdminMarkJobReported = 'AdminMarkJobReported',

  CreateNewSMSCountry = 'CreateNewSMSCountry',
  SsoProviderModal = 'SsoProviderModal',
  CreateNewWhitelistNumber = 'CreateNewWhitelistNumber',

  RepositoryBulkJobCreation = 'RepositoryBulkJobCreation',
  BulkJobCreation = 'BulkJobCreation',

  AddAdminTransactionModal = 'AddAdminTransactionModal',

  EditUserPhone = 'EditUserPhone',
  EditUserEmail = 'EditUserEmail',
  EditConcurrentJobsLimit = 'EditConcurrentJobsLimit',

  AddCourseStudent = 'AddCourseStudent',
  ChooseCloudLayout = 'ChooseCloudLayout',
  RegenerateWithLayout = 'RegenerateWithLayout',
  ConfirmCloudLayoutReset = 'ConfirmCloudLayoutReset',
  CreateNewFeatureFlag = 'CreateNewFeatureFlag',
  EditFeatureFlag = 'EditFeatureFlag',
  CreateNewAttorneyFeatureFlag = 'CreateNewAttorneyFeatureFlag',
  EditAttorneyFeatureFlag = 'EditAttorneyFeatureFlag',
  NewVersionNotification = 'NewVersionNotification',

  EditLicenseTranscriptUnlockType = 'EditLicenseTranscriptUnlockType',
  AdminEditLicenseTranscriptUnlockType = 'AdminEditLicenseTranscriptUnlockType',
  AdminEditJobTranscriptUnlockType = 'AdminEditJobTranscriptUnlockType',
  EditSubscriptionTranscriptUnlockType = 'EditSubscriptionTranscriptUnlockType',
  AdminEditSubscriptionTranscriptUnlockType = 'AdminEditSubscriptionTranscriptUnlockType',
  UpgradeToAIFeatures = 'UpgradeToAIFeatures',
  UpdateLicenseBackupRecordingFlag = 'UpdateLicenseBackupRecordingFlag',
  AcceptBackupRecordingTerms = 'AcceptBackupRecordingTerms',
  AdminBackupFilesModal = 'AdminBackupFilesModal',
  BackupFilesModal = 'BackupFilesModal',

  AdminAddNewAttorneysAccess = 'AdminAddNewAttorneysAccess',

  AddNewAttorneysAccess = 'AddNewAttorneysAccess',

  UpdateClassifiedErrorDescription = 'UpdateClassifiedErrorDescription',
  MonthPicker = 'MonthPicker',
  PeriodPicker = 'PeriodPicker',
  AllJobsFilters = 'AllJobsFilters',
  JobsListFilters = 'JobsListFilters',
  JobsReportFilters = 'JobsReportFilters',
  AdminJobsReportFilters = 'AdminJobsReportFilters',
  CasesFilters = 'CasesFilters',
  AdminTransactionsFilters = 'AdminTransactionsFilters',
}
